var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Heading, IconButton, InfoSignIcon, Pane, Paragraph, Popover, SelectMenu, Spinner, Table, } from "evergreen-ui";
import "firebase/auth";
import "firebase/firestore";
import moment from "moment";
import { memo, useContext, useEffect, useMemo, useState } from "react";
import firebase from "../config";
import { DriverContext } from "../contexts/DriverContext";
import { LocationContext } from "../contexts/LocationContext";
var MoneyInfoDialog = function (_a) {
    var tour = _a.tour;
    var locations = useContext(LocationContext).locations;
    var areBusinessLocations = locations[0], _ = locations[1];
    var _b = useState({}), tasks = _b[0], setTasks = _b[1];
    var getTasks = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tasksSnap, tasks;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, firebase
                        .firestore()
                        .collection("tasks")
                        .where("task_tour", "==", tour.id)
                        .get()];
                case 1:
                    tasksSnap = _a.sent();
                    tasks = [];
                    tasksSnap.forEach(function (snap) {
                        var data = snap.data();
                        tasks.push(data);
                    });
                    setTasks(Object.fromEntries(tasks.map(function (task) { return [
                        task.task_id,
                        { location: task.task_origin, amount: task.task_open_amount },
                    ]; })));
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getTasks();
    }, [tour]);
    var locationMap = useMemo(function () {
        return Object.fromEntries(areBusinessLocations.map(function (location) { return [location.id, location.name]; }));
    }, [areBusinessLocations]);
    var overview = useMemo(function () {
        var _a, _b, _c, _d;
        if (Object.keys(tasks).length > 0 && tour.status === "finished") {
            var cash_1 = (_b = (_a = tour === null || tour === void 0 ? void 0 : tour.cashAmountArray) === null || _a === void 0 ? void 0 : _a.map(function (taskId) { return tasks[taskId]; })) !== null && _b !== void 0 ? _b : [];
            var card_1 = (_d = (_c = tour === null || tour === void 0 ? void 0 : tour.cardAmountArray) === null || _c === void 0 ? void 0 : _c.map(function (taskId) { return tasks[taskId]; })) !== null && _d !== void 0 ? _d : [];
            var locationOverview = Object.keys(locationMap).map(function (locationId) { return ({
                name: locationMap[locationId],
                cardAmount: card_1
                    .filter(function (task) { return (task === null || task === void 0 ? void 0 : task.location) === locationId; })
                    .reduce(function (acc, cur) { return acc + parseFloat(cur.amount); }, 0),
                cashAmount: cash_1
                    .filter(function (task) { return (task === null || task === void 0 ? void 0 : task.location) === locationId; })
                    .reduce(function (acc, cur) { return acc + parseFloat(cur.amount); }, 0),
            }); });
            return locationOverview;
        }
    }, [tasks, locationMap]);
    return (_jsx(Popover, __assign({ content: _jsxs(Pane, __assign({ padding: 10, width: 240, display: "flex", flexDirection: "column" }, { children: [_jsx(Paragraph, __assign({ marginBottom: 15, textAlign: "center", fontWeight: 600 }, { children: "Eingenommene Betr\u00E4ge" })), overview === null || overview === void 0 ? void 0 : overview.map(function (location) { return (_jsxs(_Fragment, { children: [_jsxs(Paragraph, __assign({ fontWeight: 600 }, { children: [location.name, ":"] })), _jsxs(Pane, __assign({ display: "flex", flexDirection: "row", justifyContent: "space-between" }, { children: [_jsx(Paragraph, { children: "Karte:" }), _jsx(Paragraph, { children: location.cardAmount > 0 ? location.cardAmount + " €" : "-" })] })), _jsxs(Pane, __assign({ display: "flex", flexDirection: "row", justifyContent: "space-between" }, { children: [_jsx(Paragraph, { children: "Bar:" }), _jsx(Paragraph, { children: location.cashAmount > 0 ? location.cashAmount + " €" : "-" })] })), _jsxs(Pane, __assign({ display: "flex", flexDirection: "row", justifyContent: "space-between" }, { children: [_jsx(Paragraph, { children: "Gesamt:" }), _jsxs(Paragraph, { children: [location.cashAmount + location.cardAmount, "\u20AC"] })] }))] })); })] })) }, { children: _jsx(IconButton, { marginLeft: 5, icon: InfoSignIcon }) })));
};
var TableTitle = function (_a) {
    var children = _a.children;
    return (_jsx(Heading, __assign({ size: 200, style: { fontFamily: "bold" } }, { children: children })));
};
var TableText = function (_a) {
    var children = _a.children;
    return _jsx(Paragraph, __assign({ style: { fontFamily: "regular" } }, { children: children }));
};
var TableCell = function (_a) {
    var children = _a.children;
    return (_jsx(Table.Cell, __assign({ style: {
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "center",
        } }, { children: children })));
};
var TourDataTable = memo(function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var isDriverData = _a.isDriverData, tour = _a.tour, tasks = _a.tasks;
    var _r = useState(), actualDuration = _r[0], setActualDuration = _r[1];
    var _s = useState(), planedDuration = _s[0], setPlanedDuration = _s[1];
    var _t = useState(), planedTourEnd = _t[0], setPlanedTourEnd = _t[1];
    var _u = useState({}), moneyObj = _u[0], setMoneyObj = _u[1];
    var drivers = useContext(DriverContext).drivers;
    var allDrivers = drivers[0];
    var unarchivedDrivers = useMemo(function () {
        return allDrivers === null || allDrivers === void 0 ? void 0 : allDrivers.filter(function (driver) { return driver.archived !== true; });
    }, [allDrivers]);
    var calculateTimes = function () {
        var diff = moment(tour === null || tour === void 0 ? void 0 : tour.actualEndTime, "HH:mm").diff(moment(tour === null || tour === void 0 ? void 0 : tour.actualStartTime, "HH:mm"), "minutes");
        if (diff) {
            setActualDuration(diff);
        }
        var end = tour === null || tour === void 0 ? void 0 : tour.activities.find(function (_a) {
            var type = _a.type;
            return type === "end";
        });
        setPlanedTourEnd(end.action_planed_time);
        var planedDiff = moment(end.action_planed_time, "HH:mm").diff(moment(tour === null || tour === void 0 ? void 0 : tour.startTime, "HH:mm"), "minutes");
        setPlanedDuration(planedDiff);
    };
    var calculateSum = function (optionArray, moneyStore) {
        var amount = optionArray === null || optionArray === void 0 ? void 0 : optionArray.map(function (taskId) { return moneyStore.filter(function (_a) {
            var id = _a.id;
            return id === taskId;
        })[0]; });
        var sum = 0;
        amount === null || amount === void 0 ? void 0 : amount.map(function (_a) {
            var amount = _a.amount;
            sum = sum + amount;
        });
        return sum;
    };
    var calculateMoney = function () {
        try {
            var cardSum = calculateSum(tour.cardAmountArray, tour.moneyStore);
            var cashSum = calculateSum(tour.cashAmountArray, tour.moneyStore);
            var onlineSum = calculateSum(tour.onlineAmountArray, tour.moneyStore);
            var totalSum = cardSum + cashSum + onlineSum;
            setMoneyObj({ cardSum: cardSum, cashSum: cashSum, onlineSum: onlineSum, totalSum: totalSum });
        }
        catch (error) {
            console.log(error);
        }
    };
    useEffect(function () {
        // calculateTemps();
        calculateTimes();
        calculateMoney();
    }, [tour]);
    var _v = useState(false), driverChangeLoading = _v[0], setDriverChangeLoading = _v[1];
    var makeDriverChange = function (id) {
        setDriverChangeLoading(true);
        firebase
            .firestore()
            .collection("tours")
            .doc(tour.id)
            .update({ driver: id });
    };
    var selectedDriver = useMemo(function () {
        setDriverChangeLoading(false);
        return {
            data: isDriverData,
            name: (isDriverData === null || isDriverData === void 0 ? void 0 : isDriverData.firstName) + " " + (isDriverData === null || isDriverData === void 0 ? void 0 : isDriverData.lastName),
        };
    }, [isDriverData]);
    return (_jsx(Table, __assign({ style: { marginBottom: 20 } }, { children: _jsxs(Table.Body, { children: [_jsxs(Table.Row, { children: [_jsxs(TableCell, { children: [_jsx(TableTitle, { children: "FAHRER*IN" }), _jsx(TableText, { children: driverChangeLoading ? (_jsx(Spinner, { marginTop: 5, size: 16 })) : (tour === null || tour === void 0 ? void 0 : tour.driver) === "cure" ? (_jsx(Paragraph, { children: "Cure Fahrer" })) : (_jsx(_Fragment, { children: _jsx(SelectMenu, __assign({ title: "Fahrer w\u00E4hlen", options: (_b = unarchivedDrivers === null || unarchivedDrivers === void 0 ? void 0 : unarchivedDrivers.map(function (driver) { return ({
                                                label: driver.firstName + " " + driver.lastName,
                                                value: driver.id,
                                            }); })) !== null && _b !== void 0 ? _b : [], selected: selectedDriver, onSelect: function (i) { return makeDriverChange(i.value); } }, { children: _jsx(Button, { children: selectedDriver.name }) })) })) })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "Auslieferungen" }), _jsx(TableText, { children: (_d = (_c = tour === null || tour === void 0 ? void 0 : tour.successfullTasks) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0 })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "Retoure" }), _jsx(TableText, { children: (_f = (_e = tour === null || tour === void 0 ? void 0 : tour.declinedTasks) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0 })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "ID" }), _jsx(TableText, { children: tour === null || tour === void 0 ? void 0 : tour.id })] })] }), _jsxs(Table.Row, { children: [_jsxs(TableCell, { children: [_jsx(TableTitle, { children: "START- UND ENDZEIT" }), _jsxs(TableText, { children: [moment(tour === null || tour === void 0 ? void 0 : tour.actualStartTime, "HH:mm").isValid()
                                            ? moment(tour === null || tour === void 0 ? void 0 : tour.actualStartTime, "HH:mm")
                                                .add(moment(tour.actualStartTime, "HH:mm").isDST() ? 2 : 1, "hours")
                                                .format("HH:mm")
                                            : "__:__", " ", "-", " ", moment(tour === null || tour === void 0 ? void 0 : tour.actualEndTime, "HH:mm").isValid()
                                            ? moment(tour === null || tour === void 0 ? void 0 : tour.actualEndTime, "HH:mm")
                                                .add(moment(tour.actualEndTime, "HH:mm").isDST() ? 2 : 1, "hours")
                                                .format("HH:mm")
                                            : "__:__", " ", "Uhr"] })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "DAUER" }), _jsxs(TableText, { children: [actualDuration !== null && actualDuration !== void 0 ? actualDuration : "_ _", " min"] })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "SOLL: START- UND ENDZEIT" }), _jsxs(TableText, { children: [tour === null || tour === void 0 ? void 0 : tour.startTime, " - ", planedTourEnd !== null && planedTourEnd !== void 0 ? planedTourEnd : "__:__", " Uhr"] })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "SOLL: DAUER" }), _jsxs(TableText, { children: [planedDuration !== null && planedDuration !== void 0 ? planedDuration : "_ _", " min"] })] })] }), _jsxs(Table.Row, { children: [_jsxs(TableCell, { children: [_jsxs(Pane, __assign({ display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "row" }, { children: [_jsx(TableTitle, { children: "BETRAG GESAMT" }), _jsx(MoneyInfoDialog, { tour: tour, tasks: tasks })] })), _jsxs(TableText, { children: [(_h = (_g = moneyObj === null || moneyObj === void 0 ? void 0 : moneyObj.totalSum) === null || _g === void 0 ? void 0 : _g.toFixed(2)) !== null && _h !== void 0 ? _h : "0,00", " \u20AC"] })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "BAR-BETRAG" }), _jsxs(TableText, { children: [(_k = (_j = moneyObj.cashSum) === null || _j === void 0 ? void 0 : _j.toFixed(2)) !== null && _k !== void 0 ? _k : "0,00", " \u20AC"] })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "KARTEN-BETRAG" }), _jsxs(TableText, { children: [(_m = (_l = moneyObj === null || moneyObj === void 0 ? void 0 : moneyObj.cardSum) === null || _l === void 0 ? void 0 : _l.toFixed(2)) !== null && _m !== void 0 ? _m : "0,00", " \u20AC"] })] }), _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "PAYPAL-BETRAG" }), _jsxs(TableText, { children: [(_p = (_o = moneyObj === null || moneyObj === void 0 ? void 0 : moneyObj.onlineSum) === null || _o === void 0 ? void 0 : _o.toFixed(2)) !== null && _p !== void 0 ? _p : "0,00", " \u20AC"] })] })] }), _jsx(Table.Row, { children: _jsxs(TableCell, { children: [_jsx(TableTitle, { children: "DISTANZ IN KM" }), _jsxs(TableText, { children: [parseFloat(((_q = tour === null || tour === void 0 ? void 0 : tour.distance) !== null && _q !== void 0 ? _q : 0) / 1000).toFixed(2), " km"] })] }) })] }) })));
});
export default TourDataTable;
